import dynamic from 'next/dynamic';

const DynamicWineCalculatorForm = dynamic(
  () => import('../forms/wine-calculator'),
);

export const WineCalculatorSlice = () => <DynamicWineCalculatorForm />;
